import * as React from 'react';
import {
  Box, Card, CardContent, CardHeader, Grid2, TextField, Button,
  Snackbar, Alert, Stack, Divider
} from '@mui/material';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Navbar from '../setup/Navbar';
import AutoComplete from '../../BuiltInComponent/AutoComplete'
import { useDispatch, useSelector } from 'react-redux';
import { getIndividualEomployees, getEmpListForAttendance } from '../../features/PayrollManagement/employeeSlice'
import { addManualAttendance } from '../../features/PayrollManagement/attendanceSlice'

export default function ManualAttendanceForm() {

  const dispatch = useDispatch()

  const { indEmployee, empListForAtt } = useSelector((state) => state.emp)

  React.useEffect(() => {
    dispatch(getEmpListForAttendance())
  }, [dispatch])

  React.useEffect(() => {
    if (indEmployee && indEmployee.length > 0) {
      if (indEmployee[0].machineID === '') {
        setForm((f) => ({ ...f, empName: '', user_pin: '' }));
        setToast({ open: true, severity: 'error', msg: `${indEmployee[0].empName} Is not Registered in Attendance System` });

      } else {
        setForm((f) => ({ ...f, empName: indEmployee[0].empName || '', user_pin: indEmployee[0].machineID || '' }));
      }
    }
  }, [indEmployee]);

  const [form, setForm] = React.useState({
    empID: '',
    user_pin: '',
    punch_time: dayjs(),
    device_sn: 'MANUAL',
    status: '0',
    work_code: '',
    verify_mode: 'MANUAL',
    in_out_mode: 'IN',
    remarks: '',
  });

  const [loading, setLoading] = React.useState(false);
  const [toast, setToast] = React.useState({ open: false, severity: 'success', msg: '' });
  const [errors, setErrors] = React.useState({});

  const handleChange = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
  };

  const handleDateChange = (val) => {
    setForm((f) => ({ ...f, punch_time: val }));
  };

  const validate = () => {
    const e = {};
    if (!form.user_pin?.trim()) e.user_pin = 'Required';
    if (!form.punch_time || !dayjs(form.punch_time).isValid()) e.punch_time = 'Invalid date/time';
    return e;
  };

  const handleDeptChange = (data) => {
    const keys = Object.keys(data)
    dispatch(getIndividualEomployees(data[keys]))
    if (keys[0] === 'empID') {
      setForm(prev => ({ ...prev, empID: data[keys] }))
    }
  }



  const handleSubmit = async (e) => {
    e.preventDefault();
    const eobj = validate();
    setErrors(eobj);
    if (Object.keys(eobj).length) return;

    const payload = {
      user_pin: String(form.user_pin).trim(),
      punch_time: dayjs(form.punch_time).format('YYYY-MM-DD HH:mm:ss'),
      device_sn: form.device_sn?.trim() || 'MANUAL',
    };

    try {
      setLoading(true);
      dispatch(addManualAttendance(payload)).then((payload) => {
        console.log(payload.payload.data)
      })
      // const { data } = await axios.post(`${API_BASE}/api/attendance/manual`, payload, {
      //   headers: { 'Content-Type': 'application/json' },
      // });
      setToast({ open: true, severity: 'success', msg: `Attendance Added For ${form.empName}` });
      // setToast({ open: true, severity: 'success', msg: `Saved (ID: ${data?.id ?? '—'})` });
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || 'Failed';
      setToast({ open: true, severity: 'error', msg });
    } finally {
      setLoading(false);
    }
  };



  const handleReset = () => {
    setForm({
      user_pin: '',
      punch_time: dayjs(),
      device_sn: 'MANUAL',
      status: '0',
      work_code: '',
      verify_mode: 'MANUAL',
      in_out_mode: 'IN',
      remarks: '',
    });
    setErrors({});
  };

  return (
    <>
      <Navbar />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Card sx={{ maxWidth: 900, mx: 'auto', mt: 3, borderRadius: '16px', boxShadow: 3 }}>
          <CardHeader title="Manual Attendance Entry" subheader="Send attendance to /api/attendance/manual" />
          <Divider />
          <CardContent>
            <Box component="form" onSubmit={handleSubmit} noValidate>
              <Grid2 container spacing={2}>
                <Grid2 size={1.5} display={'none'}>
                  <TextField
                    label="Employee ID"
                    value={form.empID}
                    onChange={handleChange('empID')}
                    error={!!errors.empID}
                    helperText={errors.empID || 'Employee ID'}
                    fullWidth
                    required
                    size='small'
                    onBlur={() => dispatch(getIndividualEomployees(form.empID))}
                  />
                </Grid2>
                <Grid2 size={6}>
                  <AutoComplete
                    listData={empListForAtt}
                    columnName={'shiftID'}
                    label={'Shifts'}
                    value={empListForAtt.find((c) => c.empID === form.empID)}
                    // value={emp.deptDesc}
                    onChange={handleDeptChange}
                  />

                  {/* <TextField
                    // label="Employee Name"
                    value={form.empName}
                    onChange={handleChange('empName')}
                    error={!!errors.empName}
                    helperText={errors.empName || 'Employee Name'}
                    fullWidth
                    required
                    size='small'
                    disabled
                  /> */}
                </Grid2>
                <Grid2 size={2}>
                  <TextField
                    label="User PIN"
                    value={form.user_pin}
                    onChange={handleChange('user_pin')}
                    error={!!errors.user_pin}
                    helperText={errors.user_pin || 'Employee/User ID (PIN)'}
                    fullWidth
                    required
                    size='small'
                    disabled
                  />
                </Grid2>
                <Grid2 size={4}>
                  <DateTimePicker
                    label="Punch Time"
                    value={form.punch_time}
                    onChange={handleDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!errors.punch_time,
                        helperText: errors.punch_time || "Format will be sent as 'YYYY-MM-DD HH:mm:ss'",
                        size: 'small',
                      },
                    }}
                  />
                </Grid2>

                <Grid2 size={12}>
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" onClick={handleReset} disabled={loading}>
                      Reset
                    </Button>
                    <Button variant="contained" type="submit" disabled={loading}>
                      {loading ? 'Saving...' : 'Save Attendance'}
                    </Button>
                  </Stack>
                </Grid2>
              </Grid2>
            </Box>
          </CardContent>
        </Card>

        <Snackbar
          open={toast.open}
          autoHideDuration={3000}
          onClose={() => setToast((t) => ({ ...t, open: false }))}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={() => setToast((t) => ({ ...t, open: false }))}
            severity={toast.severity}
            sx={{ width: '100%' }}>
            {toast.msg}
          </Alert>
        </Snackbar>
      </LocalizationProvider>
    </>

  );
}
